import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "dashboard": "Dashboard",
      "projects": "Projects",
      "my_tasks": "My Tasks",
      "reports": "Reports",
      "team": "Team",
      "search": "Search...",
      "notifications": "Notifications",
      "toggle_theme": "Toggle Dark Mode",
      "switch_language": "Switch Language",
    }
  },
  es: {
    translation: {
      "dashboard": "Tablero",
      "projects": "Proyectos",
      "my_tasks": "Mis Tareas",
      "reports": "Reportes",
      "team": "Equipo",
      "search": "Buscar...",
      "notifications": "Notificaciones",
      "toggle_theme": "Alternar Modo Oscuro",
      "switch_language": "Cambiar Idioma",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
